import {Notification} from '../notification';

export default function makeRedirectInterval(notification: Notification, history: any, route: string) {
    const interval: number = window.setInterval(() => {
        const {type} = notification;
        
        if (type === 'success') {
            history.push(route);
            stopTimer(interval);
        }
        
        if (type === 'error')
            stopTimer(interval);
    }, 500);
}

export const stopTimer = (interval: number) => {
    clearInterval(interval);
};
